import { Injectable } from '@angular/core';
import 'rxjs/Rx';
import { ApiService } from '../authentication/guards/api.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { IOption } from 'ng-select';

@Injectable()
export class OfferService {
  constructor(private apiService: ApiService) { }

  getListOfOffer(id, showExpiredOffers) {
    return this.apiService.get('/offerlist/' + id + '/' + (showExpiredOffers ? 1 : 0)).map(data => data);
  }

  create(offer, appid) {
    return this.apiService.post('/offer/' + appid, offer).map(data => data);
  }

  delete(id, appid) {
    return this.apiService.delete('/offer/' + appid + '/app/' + id).map(data => data);
  }

  getOfferById(id) {
    return this.apiService.get('/offer/' + id).map(data => data);
  }

  approve(offer, appid) {
    return this.apiService.post('/offerapproved/' + appid, offer).map(data => data);
  }

  reject(offer, appid) {
    return this.apiService.post('/offerrejected/' + appid, offer).map(data => data);
  }

  getListOfOfferRequests(appId) {
    return this.apiService.get('/offerrequestlist/' + appId).map(data => data);
  }


  getListOfRedeemedOrConfirmed(ItemId, ItemType) {
    return this.apiService.get('/confirmedorredeemed/' + ItemType + '/itemtype/' + ItemId).map(data => data);
  }

  getListOfRedeemedOrConfirmedToExport(ItemId, ItemType) {
    return this.apiService.get('/exportconfirmedorredeemed/' + ItemType + '/itemtype/' + ItemId).map(data => data);
  }
}



// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/app/services/offer-management/offer-management.ts